import cx from "classnames";
import React from "react";

import { Features } from "@/mk2/apps/strollers/schemas";
import { niceNumber } from "@/mk2/apps/strollers/utils";
import { hasVal } from "@/mk2/helpers/sanitize";

import styles from "./TwoDimsFeature.mscss";

interface OwnProps {
    className?: string;
    features: Features;
    feature: any;
}

const renderValue = (value) => {
    return hasVal(value) ? niceNumber(value) : "?";
};

export class TwoDimsFeature extends React.Component<OwnProps> {
    public render() {
        const { feature, features, className } = this.props;

        if (!feature.hasWorthyValue(features)) {
            return null;
        }

        const dims = feature.getDims(features);

        return (
            <div className={cx(styles.TwoDimsFeature, className)}>
                {renderValue(dims.width)}
                &nbsp;×&nbsp;
                {renderValue(dims.depth)}
            </div>
        );
    }
}
